__turbopack_context__.v({
  "blok-big-title": "ReactVideoPlayer-module__18msVW__blok-big-title",
  "blok-subtitle": "ReactVideoPlayer-module__18msVW__blok-subtitle",
  "blok-title": "ReactVideoPlayer-module__18msVW__blok-title",
  "reactVideoPlayer": "ReactVideoPlayer-module__18msVW__reactVideoPlayer",
  "videoWrapper": "ReactVideoPlayer-module__18msVW__videoWrapper",
});
